import { Paper } from "@material-ui/core";
import { Paginate } from "components";
import { usePopup } from "hooks/usePopup";
import { useEffect, useRef, useState } from "react";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import batchService from "services/batchService";
import { useDebaunce } from "utils";

import { BatchTable } from "../EntryTable/BatchTable";
import {
  CustomTableContainer,
  PaginateContent,
  SearchContent,
  SearchInput
} from "../EntryTable/style";
import { formatData } from "../utils/formatData";
import { Confirm } from "./Confirm";

export const RefusalTable = () => {
  const confirmRef = useRef(null);
  const { addPopup } = usePopup();
  const [batchData, setBatchData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const controller = new AbortController();
  const signal = controller.signal;

  const debaunceSearch = useDebaunce({ fn: handleSearch, delay: 800 });

  const getInitData = async () => {
    try {
      setLoading(true);
      setBatchData([]);
      const toDayDate = new Date();
      const receiptDateFrom = new Date(toDayDate);
      receiptDateFrom.setDate(receiptDateFrom.getDate() - 2);
      receiptDateFrom.setHours(0, 0, 0, 1);

      const params = {
        status: "4, 5",
        page,
        receiptDateFrom,
        receiptDateTo: new Date(toDayDate.setHours(23, 59, 59, 0)),
        search: search?.trim(),
        signal
      };
      const { data } = await batchService.getBatches(params);

      setBatchData(formatData(data.results));
      setTotalPages(data.pageSize);
    } catch (error) {
      if (!signal.aborted) {
        const errorMessage = error?.response?.data?.msg;
        addPopup({
          type: "error",
          title: "Erro ao carregar lotes",
          description: errorMessage
        });
      }
    } finally {
      setLoading(false);
    }
  };

  function resetPage() {
    setPage(1);
  }
  function handleChangePage(e) {
    const selectedPage = e.selected + 1;
    setPage(selectedPage);
  }

  function handleSearch(e) {
    const { value } = e.target;
    resetPage();
    setSearch(value);
  }

  const handleOpenConfirm = batchId => {
    const data = batchData.find(({ id }) => id === batchId);
    confirmRef.current?.handleOpen(data);
  };

  useEffect(() => {
    getInitData();
    return () => {
      controller.abort();
    };
  }, [page, search]);

  return (
    <>
      <CustomTableContainer component={Paper}>
        <SearchContent>
          <SearchInput
            placeholder="Seller ou produto"
            onChange={debaunceSearch}
          />
        </SearchContent>

        <BatchTable
          batchData={batchData}
          loading={loading}
          handleOpenConfirm={handleOpenConfirm}
          isRefusal
        />

        <PaginateContent>
          {totalPages > 1 && (
            <Paginate
              breakLabel="..."
              nextLabel={<AiOutlineRight />}
              forcePage={page - 1}
              onPageChange={handleChangePage}
              pageRangeDisplayed={3}
              pageCount={totalPages}
              previousLabel={<AiOutlineLeft />}
              renderOnZeroPageCount={null}
              loading={loading}
            />
          )}
        </PaginateContent>
      </CustomTableContainer>
      <Confirm ref={confirmRef} refresh={() => getInitData()} />
    </>
  );
};
